import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { AppFocusRestoreService } from '@core/services/app-focus-restore.service';

@Directive({
  selector: '[appFocusTarget]',
})
export class AppFocusTargetDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly focusRestore = inject(AppFocusRestoreService);

  public readonly appFocusTarget = input.required<string>();

  constructor() {
    effect((onCleanup) => {
      const key = this.appFocusTarget();
      const element = this.host.nativeElement;

      this.focusRestore.register(key, element);
      onCleanup(() => this.focusRestore.unregister(key, element));
    });
  }
}
